import { useEffect, useState } from "react";
import { KbvPluginService } from "@/services/kbvPluginService";

const useLeagueBySlug = (slug) => {
  const [league, setLeague] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;

    let isMounted = true;

    const fetchLeague = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await KbvPluginService.getLeagueBySlug(slug);

        if (isMounted) {
          setLeague(data);
        }
      } catch (err) {
        console.error(err);
        if (isMounted) {
          setError(err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchLeague();

    return () => {
      isMounted = false;
    };
  }, [slug]);

  return {
    league,
    loading,
    error,
  };
};

export default useLeagueBySlug;
